export default "__VITE_ASSET__c9127c53__"